import { render, staticRenderFns } from "./DomicileModal.vue?vue&type=template&id=167091d1"
import script from "./DomicileModal.vue?vue&type=script&lang=js"
export * from "./DomicileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports